<app-loading *ngIf="isLoading"></app-loading>
<div class="m-4">
  <div class="row px-3">
    <div class="col-6">
      <p class="titleFont">
        {{ "label.claim.claimDetails.hospitalDetails" | translate }}
      </p>
    </div>
    <div class="col-6 text-right">
      <div class="circle circle-plus">
        <img src="{{ addIcon }}" alt="Plus Icon" class="plus-icon" />
      </div>
    </div>
  </div>
  <ng-container *ngIf="getHospitalDetails.length > 0">
    <ng-container *ngIf="selectedCircleIndex >= 0">
      <div class="card mt-2 px-3 pt-4 pb-2">
        <div class="circle-container">
          <div
            *ngFor="let circle of getHospitalDetails; let i = index"
            class="circle"
            [ngClass]="{
              'blue-border': selectedCircleIndex === i,
              'purple-color': selectedCircleIndex !== i
            }"
            (click)="selectCircle(i)"
          >
            {{ i + 1 }}
          </div>
        </div>

        <div class="row labelContent mt-3">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
            <p>{{ "label.claim.claimDetails.hospital" | translate }}</p>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12">
            <custom-input-text
              placeholder="-"
              (valueChange)="onDataInput($event, 'hospitalName')"
              [model]="hospitalDetail.hospitalName"
              [disabled]="true"
            ></custom-input-text>
          </div>
        </div>
        <div class="row labelContent">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
            <p>{{ "label.claim.claimDetails.contactNo" | translate }}</p>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12 d-flex">
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 px-0">
              <custom-select placeholdername="-"
              [autoOptions]="dialCodesArr"
              (valueChange)="onDataInput($event, 'countryCode')"
              [value]="hospitalDetail.countryCode"
              [disabled]="true"
              ></custom-select>
            </div>
            <div
              class="col-xl-10 col-lg-10 col-md-9 col-sm-12 px-0 contactInput"
            >
              <custom-input-text
                placeholder="-"
                (valueChange)="onDataInput($event, 'contactNumber')"
                [model]="hospitalDetail.contactNumber"
                [disabled]="true"
              ></custom-input-text>
            </div>
          </div>
        </div>
        <div class="row labelContent">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
            <p>{{ "label.claim.claimDetails.hospitalAddress" | translate }}</p>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12">
            <custom-input-text
              placeholder="-"
              (valueChange)="onDataInput($event, 'hospitalAddress')"
              [model]="hospitalDetail.hospitalAddress"
              [disabled]="true"
            ></custom-input-text>
          </div>
        </div>
        <!-- <hr /> -->
      </div>
      <div class="card px-3 py-4">
        <table class="borderless-table dashabordTable table-responsive-sm">
          <thead>
            <tr class="header-filter pt-2 pb-3">
              <th>
                {{
                  "label.claim.claimDetails.nameOfPhysicianSurgeon" | translate
                }}
              </th>
              <th>
                {{ "label.claim.claimDetails.dateOfConsultation" | translate }}
              </th>
              <th>
                {{
                  "label.claim.claimDetails.proceduresAndOperationsDone"
                    | translate
                }}
              </th>              
            </tr>
          </thead>
          <tbody>
            <tr
              class="table-header"
              *ngFor="let item of hospitalDetail.surgeons; index as i"
            >
              <td>
                <custom-input-text
                  (valueChange)="
                    onSurgeonInput($event, 'natureOfSurgeons', item.uuid)
                  "
                  [model]="item.natureOfSurgeons"
                  [disabled]="true"
                >
                </custom-input-text>
              </td>
              <td>
                <custom-date-picker
                  (valueChange)="
                    onSurgeonInput($event, 'dateOfConsultation', item.uuid)
                  "
                  [model]="item.dateOfConsultation"
                  [disabled]="true"
                >
                </custom-date-picker>
              </td>
              <td class="text-center">              
                <img
                  class="notesIcon"
                  src="{{ notesIcon }}"
                  (click)="onOpenProcedureDialog(item, i)"
                  alt=""
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </ng-container>
  <div class="row endButtons">
    <custom-button
      class="saveBtn"
      label="{{ 'processClaims.decisionAndSettlement.save' | translate }}"
      mode="primary"
      margin="xsmall"
      (onClick)="onCloseDialog()"
    >
    </custom-button>
    <custom-button
      class="cancelBtn"
      label="{{ 'processClaims.decisionAndSettlement.cancel' | translate }}"
      mode="secondary"
      margin="xsmall"
      (onClick)="onCloseDialog()"
    >
    </custom-button>
  </div>
</div>

<dxc-dialog class="dialog-content" *ngIf="isProcedure" [isCloseVisible]="false">
  <div class="m-4">
    <div class="row px-3">
      <div class="col-12 text-left">
        <p class="titleFont">
          {{
            "label.claim.claimDetails.proceduresAndOperationsDone" | translate
          }}
        </p>
      </div>
    </div>
    <div class="px-3 py-4">
      <div class="row mb-2">
        <div class="col-11">
          <custom-textarea
            class="textArea"
            (valueChange)="
              onChangesPrescriptionInput($event, this.surgeonIndex)
            "
            [value]="
              this.hospitalDetail.surgeons[this.surgeonIndex].prescription
            "
            [disabled]="true"
          >
          </custom-textarea>
        </div>
        <div class="col-1 Image">
          <img class="editIconPro" src="{{ editIcon }}" alt="" />
        </div>
      </div>

      <div class="row endButtons">
        <custom-button
          class="saveBtn"
          label="{{ 'processClaims.decisionAndSettlement.save' | translate }}"
          mode="primary"
          margin="xsmall"
          (onClick)="onCloseProcedure()"
        >
        </custom-button>
        <custom-button
          class="cancelBtn"
          label="{{ 'processClaims.decisionAndSettlement.cancel' | translate }}"
          mode="secondary"
          margin="xsmall"
          (onClick)="onCloseProcedure()"
        >
        </custom-button>
      </div>
    </div>
  </div>
</dxc-dialog>
